import { render, staticRenderFns } from "./FullWidthRecipes.vue?vue&type=template&id=a522705a&scoped=true&"
import script from "./FullWidthRecipes.vue?vue&type=script&lang=js&"
export * from "./FullWidthRecipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a522705a",
  null
  
)

export default component.exports